module.exports = __webpack_public_path__ + "static/media/white-shield.db4e64c7.svg";